//repeatable code
import React from 'react';
import { Input } from 'antd';
import D_Number from '@utils/number';

export const formatters = {
  formatNumberToString: (e, decPoints = 1) =>
    D_Number.format(e, 'none', decPoints),
  formatPercentToString: (p) => D_Number.formatPercentage(p, 1),

  formatEarningsPerShare(num) {
    if (typeof num != 'number') {
      return '-';
    }
    return `${formatters.formatNumberToString(num, 2)} ${this.currency || ''}`;
  },
};

const CustomizedFormatForFinancials = {
  formatNumberToString: {
    fields: [
      'totalRevenue',
      'grossProfit',
      'operatingExpense',
      'operatingIncome',
      'netIncome',
      'marketCap',
      'enterPriseValue',
      'sgaExpense',
      'generalAdministrativeExpense',
      'salesMarketingExpense',
    ],
  },
  formatPercentToString: {
    fields: ['salesGrowthYoy', 'grossMargin'],
  },
  formatEarningsPerShare: {
    fields: ['earningsPerShare'],
  },
};

const formatNullValue = (e) => {
  if (e === 0) {
    return 0;
  }
  if (!e) {
    return '-';
  }
  return e;
};

const clickableRows = [
  'totalRevenue',
  'grossProfit',
  'sgaExpense',
  'operatingIncome',
  'netIncome',
  'earningsPerShare',
  'marketCap',
];

// const editableRows = ['fiscalYearEnd'];

export const formatFinancials = (data) => {
  const result = Array.prototype.concat(
    [],
    Array.isArray(data) &&
      data
        .map((e) => Object.assign({}, e))
        //TODO: To-Remove By Backend
        .filter((e) => !['accountingRegulation'].includes(e.info.resourceId)),
  );
  const [buyer, target] = ['buyer', 'target'].map(
    (role) =>
      Array.isArray(data) &&
      data.reduce(
        (acc, e) => Object.assign(acc, { [e.info.resourceId]: e[role] }),
        {},
      ),
  );

  result.forEach((e) => {
    [e.buyer, e.target] = [e.buyer, e.target].map(formatNullValue);
    e.info.clickable = clickableRows.includes(e.info.resourceId);
    // e.info.editable = editableRows.includes(e.info.resourceId);
    const format = Object.keys(CustomizedFormatForFinancials).find((k) =>
      CustomizedFormatForFinancials[k].fields.includes(e.info.resourceId),
    );
    if (format) {
      const formatMethod = formatters[format] || (() => {});
      e.buyer = formatMethod.call(buyer, e.buyer);
      e.target = formatMethod.call(target, e.target);
    }
  });
  return result;
};

export const EditableCell = (props) => {
  const { isEditing = false, value, defaultValue, onChange } = props;
  return isEditing ? (
    <Input defaultValue={defaultValue} onChange={onChange} />
  ) : (
    value
  );
};
